$(function() {
  // TODO: Refactor this as part of large optional theme settings
  $('#filters').on('change', function(e) {
    var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

    if (e.target.type == 'range' || isMobile) { return; }
    $('#filters').submit();
  });
});
